/**
 * Get cookie by name
 * @param {String} name Cookie name
 * @returns {String|null}
 */
const readCookie = (name) => {
  const cookies = document.cookie.split(';').reduce((acc, i) => {
    const ck = i.trim();
    const ckSplit = ck.split('=');
    acc[ckSplit[0]] = ckSplit.slice(1).join('=');
    return acc;
  }, {});

  return cookies[name] || null;
};

export default readCookie;
